export function getAuthToken() {
  return localStorage.getItem("token") || null;
}

export function getUserProfile() {
  try {
    const userInfo = localStorage.getItem("userInfo");
    if (!userInfo) return null;
    return userInfo === "superAdmin" ? "superAdmin" : JSON.parse(userInfo);
  } catch {
    return null;
  }
}

export function getActiveRestaurantId() {
  try {
    const rawStore = localStorage.getItem("storeInfo");
    if (rawStore && rawStore !== "superAdmin") {
      const parsedStore = JSON.parse(rawStore);
      if (parsedStore?._id) return parsedStore._id;
      if (parsedStore?.id) return parsedStore.id;
    }
  } catch {}

  try {
    const userInfo = getUserProfile();
    if (userInfo && typeof userInfo === "object") {
      if (userInfo.restaurantId) return userInfo.restaurantId;
      if (userInfo.restaurant?._id) return userInfo.restaurant._id;
      if (userInfo.restaurant?.id) return userInfo.restaurant.id;
      if (typeof userInfo.restaurant === "string" && userInfo.restaurant.length === 24) {
        return userInfo.restaurant;
      }
    }
  } catch {}

  return null;
}

export function getStoreInfo() {
  try {
    const rawStore = localStorage.getItem("storeInfo");
    if (rawStore === "superAdmin") return "superAdmin";

    let storeInfo = null;
    if (rawStore) {
      try {
        storeInfo = JSON.parse(rawStore);
      } catch {
        storeInfo = null;
      }
    }

    // If storeInfo is empty object or missing _id, fall back to userInfo
    if (!storeInfo || (typeof storeInfo === "object" && !storeInfo._id && !storeInfo.id)) {
      const userInfo = getUserProfile();
      if (userInfo && typeof userInfo === "object") {
        if (
          userInfo.restaurant &&
          typeof userInfo.restaurant === "object" &&
          (userInfo.restaurant._id || userInfo.restaurant.id)
        ) {
          return userInfo.restaurant;
        }
        if (userInfo.restaurantId) {
          return { ...(storeInfo || {}), _id: userInfo.restaurantId };
        }
      }
    }

    return storeInfo;
  } catch {
    return null;
  }
}

export function getSubscriptionInfo() {
  try {
    const planDetails = localStorage.getItem("planDetails");
    if (!planDetails) return null;
    return planDetails === "superAdmin" ? "superAdmin" : JSON.parse(planDetails);
  } catch {
    return null;
  }
}
